export default "__VITE_ASSET__DqV_RhKU__"